module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_veteran.780a0e9b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_veteran.png
// module id = 3467
// module chunks = 11